<template>
  <v-container>
    <v-snackbar
      class="snackbar-top"
      v-model="notification.show"
      :top="true"
      :right="true"
      :color="notification.color"
    >
      {{ notification.message }}
      <v-btn
        fab small outlined
        @click="closeNotification"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>

    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{$t('forms.name')}}</th>
            <th class="text-left">{{$t('forms.description')}}</th>
            <th class="text-center">
              <v-btn @click="addComponent" fab small color="primary" :disabled="loading">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn @click="loadComponents" fab small color="primary" class="ml-2" :disabled="loading">
                <v-icon>refresh</v-icon>
              </v-btn>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="component in components" :key="component.id">
            <td>{{ component.name }}</td>
            <td>{{ component.description }}</td>
            <td class="text-center">
              <v-btn @click="editComponent(component)" fab small :disabled="loading" color="blue accent-1" dark>
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn @click="removeComponent(component)" fab small :disabled="loading" class="ml-2" color="red accent-1" dark>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog width="700" v-model="dialog_form">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{current_component.id ? $t('forms.edit-record', {name: $t('forms.components.component')}) : $t('forms.create-record', {name: $t('forms.components.component')})}}
        </v-card-title>
        <v-card-text>
          <v-alert type="error" dismissible v-if="error" class="mt-5">{{error}}</v-alert>
          <v-alert type="success" dismissible v-if="notice" class="mt-5">{{notice}}</v-alert>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="5" align="center" class="pt-2">
                <v-img :src="current_component.image" width="280" height="210"></v-img>
                <v-file-input
                  v-model="images.current"
                  :label="$t('forms.change-thumbnail')"
                  prepend-icon=""
                  chips
                  clearable
                  clear-icon="clear"
                  :rules="images.rule"
                  accept="image/jpeg"
                  @change="changeThumbnail"
                  @clear="changeThumbnail"
                  ></v-file-input>
                <p class="text-left">
                  {{$t('forms.only-images', {type: 'JPG/JPEG', ratio: '4:3', width: 480, height: 360, size: '300 Kb'})}}
                </p>
              </v-col>
              <v-col cols="7">
                <v-text-field
                  :label="$t('forms.name')"
                  type="text"
                  v-model="current_component.name"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.name')})]"
                  required
                ></v-text-field>

                <v-textarea
                  solo
                  :label="$t('forms.description')"
                  v-model="current_component.description"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.description')})]"
                  required
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveComponent" :loading="loading" :disabled="loading">
            {{$t('forms.save')}}
            <template v-slot:loader>
              <span>{{$t('forms.loading-save')}}</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_remove" max-width="500">
        <v-card>
            <v-card-title class="headline">{{$t('forms.sure-remove', {name: current_component.name})}}</v-card-title>
            <v-card-text>
                <p>{{$t('forms.sure-remove-description')}}</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancelRemove">
                    {{ $t('forms.no-remove') }}
                </v-btn>
                <v-btn color="red accent-2" dark @click="confirmRemoveComponent">
                    {{ $t('forms.confirm-remove') }}
                </v-btn>
            </v-card-actions>
            <v-overlay
              :value="loading"
              >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-overlay>
        </v-card>
   </v-dialog>

   <v-overlay :value="!loaded" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<style lang="scss">
  .v-snack--top {
      top: 5em !important;
  }
</style>

<script>
import * as service from '@/store/module/component'
import { getUrlImage, uploadImage, removeImage } from '@/store/storage'

export default {
  data() {
    return {
      components: [],
      valid: false,
      loaded: false,
      loading: false,
      error: null,
      notice: null,
      dialog_form: false,
      dialog_remove: false,
      current_component: null,
      notification: {
        color: 'gree',
        show: false,
        message: ''
      },
      images: {
        example: null,
        default: null,
        current: null,
        rule: [v => !v || v.size < 200000 || this.$t('errors.image-size', {size: '200 Kb'})]
      }
    }
  },
  created() {
    this.resetForm()
    this.loadComponents()

    getUrlImage(null, 'component', true).then(url => {
      this.images.example = url
    })
  },
  methods: {
    showNotification(success, message) {
      this.notification.message = message
      this.notification.color = success ? 'green' : 'red'
      this.notification.show = true
    },
    closeNotification() {
      this.notification.show = false
      this.notification.message = ''
    },
    loadComponents() {
      this.loaded = false
      service.getDocumentsFromCollection('components').then(result => {
        this.components = result
        this.loaded = true
      })
    },
    resetForm() {
      this.current_component = {
        id: null,
        name: '',
        description: '',
        image: this.images.example
      }
      this.images.current = null
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    openFormDialog() {
      this.dialog_form = true
    },
    closeFormDialog() {
      this.dialog_form = false
    },
    openRemoveDialog() {
      this.dialog_remove = true
    },
    closeRemoveDialog() {
      this.dialog_remove = false
    },
    removeComponent(component) {
      this.current_component = component
      this.openRemoveDialog()
    },
    cancelRemove() {
      this.closeRemoveDialog()
      this.resetForm()
    },
    confirmRemoveComponent() {
      service.removeComponent(this.current_component.id)
        .then(async () => {
          await removeImage(this.current_component.id, 'component')
          this.showNotification(true, this.$t("forms.data-removed"))
          this.cancelRemove()
          this.loadComponents()
        })
        .catch(() => {
          this.showNotification(true, this.$t("errors.remove"))
        })
    },
    getUrlImage(image) {
      return getUrlImage(image, 'component', true)
    },
    addComponent() {
      this.resetForm()
      this.openFormDialog()
    },
    async editComponent(component) {
      this.loading = true
      this.resetForm()
      // Thumbnail
      if (!component.image) {
        component.image = this.images.example
        component.image_loaded = true
      } else if (!component.image_loaded) {
        await getUrlImage(component.image, 'component', true).then(url => {
          component.image = url
          component.image_loaded = true
        })
      }

      this.current_component = {
        id: component.id,
        name: component.name,
        description: component.description,
        image: component.image
      }
      this.openFormDialog()
      this.loading = false
    },
    changeThumbnail() {
      if (!this.images.current) {
        this.images.current = null
      }
    },
    saveComponent() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.notice = null
        this.error = null

        let component = {
          id: this.current_component.id ? this.current_component.id : null,
          name: this.current_component.name,
          description: this.current_component.description
        }

        let action_save = this.current_component.id ? service.updateComponent : service.createComponent
        action_save(component)
        .then(async document => {
          // Upload image
          if (this.images.current) {
            uploadImage(document.id, 'component', this.images.current)
              .then(result => {
                let success = result.state === 'success'
                this.showNotification(success, success ? this.$t("results.image-uploaded") : this.$t("errors.upload-failed"))
                if (success) {
                  service.updateComponentThumbnail(document.id)
                }
              })
          }
          // End save process
          this.showNotification(true, this.$t("forms.saved-record"))
          this.closeFormDialog()
          this.$refs.form.reset()
          this.loading = false
          this.loaded = false
          this.loadComponents()
        })
        .catch(error => {
          this.error = error.message
          this.loading = false
        })
      }
    }
  }
}
</script>
